import { AfterContentChecked, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnexoRepository } from '@app/data/anexo/anexo.repository'; 
import { DetalhesAtendimentoComponent } from '@app/modules/atendimentos/components/detalhes-atendimento/detalhes-atendimento.component';
import { AnexosComponent } from '@app/shared/components/anexos/anexos.component';
import * as moment from 'moment';

@Component({
  selector: 'app-anexos-veiculo',
  templateUrl: './anexos-veiculo.component.html',
  styleUrls: ['./anexos-veiculo.component.scss']
})
export class AnexosVeiculoComponent implements AfterContentChecked {
  @ViewChild('anexos') anexos: AnexosComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { codigoVeiculo: string },
    private dialogRef: MatDialogRef<DetalhesAtendimentoComponent>,
    private changeDetector: ChangeDetectorRef, 
    private anexoRepository: AnexoRepository,
  ) { }

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.anexoRepository.getAnexos('Veiculos', this.data.codigoVeiculo).subscribe((data: any[]) => {
      if (this.anexos) {
        const hojeZerado = moment().startOf('day');
  
        const anexosValidos = data.filter(anexo => {
          if (anexo.dataValidade) {
            const apenasDataString = anexo.dataValidade.split('T')[0];
            const dataValidade = moment(apenasDataString, 'YYYY-MM-DD');
            return dataValidade.isSameOrAfter(hojeZerado, 'day');
          }
          return true;
        });
  
        this.anexos.setSentFiles(anexosValidos);
      }
    });
  }

  protected onClose() {
    this.dialogRef.close(false);
  }
}
